/**
 * @generated SignedSource<<ac07f04596aabe1a20ba350dbfe00674>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BookingStatus = "CONFIRMED" | "DRAFT";
import { FragmentRefs } from "relay-runtime";
export type DiningReservationFooter_booking$data = {
  readonly diningReservationHold?: {
    readonly expiresAt: string | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly status?: BookingStatus;
  readonly " $fragmentType": "DiningReservationFooter_booking";
};
export type DiningReservationFooter_booking$key = {
  readonly " $data"?: DiningReservationFooter_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"DiningReservationFooter_booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DiningReservationFooter_booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DiningReservationHold",
          "kind": "LinkedField",
          "name": "diningReservationHold",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expiresAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "DiningBooking",
      "abstractKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "dc83f08d0f09ac0c32ba62d94219f85d";

export default node;
